import type { SVGProps } from "react";
export interface FileDollarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FileDollarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FileDollarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M2.875 19V5A4.125 4.125 0 0 1 7 .875h6.586c.293 0 .58.063.844.177l.022.009q.258.115.48.296l.157.14 5.414 5.415c.18.18.322.39.426.618q.012.022.022.047c.113.262.174.547.174.838V19A4.125 4.125 0 0 1 17 23.125H7A4.125 4.125 0 0 1 2.875 19m12.25-13c0 .484.392.875.875.875h1.285l-2.16-2.16zm-10 13c0 1.035.84 1.875 1.875 1.875h10c1.036 0 1.875-.84 1.875-1.875V9.125H16A3.125 3.125 0 0 1 12.876 6V3.125H7c-1.036 0-1.875.84-1.875 1.875z"
      />
      <path
        fill={color}
        d="m11.297 13.278.004.051.002.006.003.003.007.01q.013.015.054.046c.134.097.401.21.854.3 1.238.247 2.732 1.106 2.732 2.83 0 1.231-.782 2.224-1.843 2.64a1.122 1.122 0 0 1-2.219.024 2.9 2.9 0 0 1-1.714-1.608l-.072-.193-.03-.112a1.124 1.124 0 0 1 2.122-.706l.043.107.03.075a.64.64 0 0 0 .187.218c.103.078.271.155.543.155.453 0 .703-.324.703-.6 0-.096-.028-.182-.148-.289a1.4 1.4 0 0 0-.514-.268l-.262-.067c-.563-.113-1.21-.304-1.736-.687-.584-.425-.996-1.076-.996-1.937q0-.053.004-.105l.002-.003c.046-1.16.853-1.984 1.837-2.342a1.123 1.123 0 0 1 2.218-.013c.84.298 1.427.921 1.715 1.608l.073.192.03.111a1.126 1.126 0 0 1-2.123.708l-.043-.107-.03-.075a.64.64 0 0 0-.187-.22c-.103-.077-.271-.155-.543-.155a.9.9 0 0 0-.573.185c-.113.094-.13.174-.13.213z"
      />
    </svg>
  );
}
